const experiences = [{
        name: 'Self Solutions',
        job: 'Estágio em Desenvolvimento Web',
        description: 'Estágio para desenvolvimento de aplicações com foco no Front-end utilizando ReactJS. Trabalhando no desenvolvimento de uma aplicação de monitoramento em tempo real, utilizando mapas que visa a emissão de alertas de risco para empresas de acordo com as condições metereológicas.',
        date: 'Maio, 2022 - Hoje'
    },
    {
        name: 'Black Bee Drones',
        job: 'Software Developer',
        description: 'Desenvolvimento de algoritmos capazes de resolver problemas com reconhecimento de imagem, a partir do controle de Drones autônomos.',
        date: '2019 - 2021'
    },
    {
        name: 'Universidade Federal de Itajubá - Minas Gerais',
        job: '  Engenharia de Controle e Automação',
        date: '2018 - Hoje'
    },
    {
        name: 'Colégio Técnico Industrial de Guaratinguetá - CTIG',
        job: 'Técnico em Eletroeletrônica',
        date: '2015 - 2017'
    }
]
export default experiences;